module.exports = "/_next/static/images/InaccurateData@2x-6fd0c05a69489e09c92e740e2995f7ae.webp";